export class ApiEndpoint {
  static updateClinicianProfileContact = 'updateClinicianProfile';
  static sendChatMessage = 'sendChatMessage';
  static sendEmail = '/sendEmail';
  static createChatSession = 'createChatSession';
  static addConsumerContent = 'addConsumerContent';
  static getPatientConsult = 'getPatientConsult';
}
